import type { StockFilter, StockItem } from '@/domain/Stock';
import { api } from '@/lib/api';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface StockResponse {
  data: Array<StockItem>;
  links?: {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
  };
  meta?: {
    current_page: number;
    from: number;
    last_page: number;
    path: string;
    per_page: number;
    to: number;
    total: number;
  };
}

export interface StockQueryParams {
  page?: number;
  filter?: StockFilter;
  search?: string;
}

export const getStockQuery = (
  page = 1,
  filter?: StockFilter,
  search?: string,
) =>
  queryOptions({
    queryKey: queryKeys.stock.all(page, filter, search),
    queryFn: async () => {
      const searchParams: Record<string, string | number | boolean> = { page };

      if (filter === 'low') searchParams.low_stock = true;
      if (filter === 'out') searchParams.out_of_stock = true;
      if (search) searchParams.search = search;

      const response = await api
        .get('items-stock', { searchParams })
        .json<StockResponse>();
      return response;
    },
    placeholderData: keepPreviousData,
  });
